import { render, staticRenderFns } from "./ListProductions.vue?vue&type=template&id=dae900c4"
import script from "./ListProductions.vue?vue&type=script&lang=js"
export * from "./ListProductions.vue?vue&type=script&lang=js"
import style0 from "./ListProductions.vue?vue&type=style&index=0&id=dae900c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports